/* eslint-disable no-undef */
import whenElementsOnViewport from '../utils/whenElementsOnViewport';
import loadScript from '../utils/loadScript';

export default () => {
  const $ymap = $('#ymap');
  if ($ymap.length === 0) {
    return;
  }

  const ymapInit = () => {
    loadScript('https://api-maps.yandex.ru/2.0/?load=package.standard&lang=ru-RU')
      .then(() => {
        let centerCoordinates = [45.027069, 39.014477];

        if (window.matchMedia('(max-width: 767px)').matches) {
          centerCoordinates = [45.027069, 39.018477];
        }
        ymaps.ready(() => {
          const myMap = new ymaps.Map('ymap', {
            center: centerCoordinates,
            zoom: 16,
          });
          const myPlacemark = new ymaps.Placemark(
            [45.027069, 39.018477],
            {
              iconCaption: 'МЧС-ПАРТНЁР',
              balloonContent: 'г. Краснодар, ул. Селезнёва 4/4, помещение 5',
            },
            {
              iconLayout: 'default#image',
              iconImageHref: '/nor/img/common/placemark.svg',
              iconImageSize: [58, 70],
              iconImageOffset: [-20, -65],
            },
          );
          myMap.geoObjects.add(myPlacemark);

          myMap.behaviors.disable('scrollZoom');
          myMap.controls.add('zoomControl');
        });
      });
  };

  const ymap = Array.from(document.querySelectorAll('.ymap'));
  whenElementsOnViewport(ymap, ymapInit);
};
